import selectedClient from "virtual:client-config";

// Vite resolves this virtual import to the JSON selected by CLIENT_SLUG.
// Moon Coffee remains the default so the existing build and deployment stay unchanged.
export const currentClientData: unknown = selectedClient;
